import { useTranslate } from "@refinedev/core";
import type { QuizDifficulty } from "../types";
import { AUTOMATIC_DIFFICULTY } from "../quiz/helpers";

/** Select options for the Quiz add-on config card. */
export const useQuizConfigData = () => {
  const t = useTranslate();

  const difficultyOptions: {
    value: QuizDifficulty | typeof AUTOMATIC_DIFFICULTY;
    label: string;
  }[] = [
    {
      value: AUTOMATIC_DIFFICULTY,
      label: t("createExperience.addOns.quiz.difficulty.automatic"),
    },
    {
      value: "Simple",
      label: t("createExperience.addOns.quiz.difficulty.simple"),
    },
    {
      value: "Balanced",
      label: t("createExperience.addOns.quiz.difficulty.balanced"),
    },
    {
      value: "Expert",
      label: t("createExperience.addOns.quiz.difficulty.expert"),
    },
  ];

  return { difficultyOptions };
};
